import React, { useEffect } from "react";
import { Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import ProtectedRoute from "./common/protectedRoute/protectedRoute";
import Snackbar from "./common/views/Snackbar";
import ResponsiveDialog from "./common/views/responsiveDialog";
import { PATH, TITLE } from "./constants/appConstants";
import AddNewsMobile from "./containers/addNews/addNewsMobile";
import AddStoriesMobile from "./containers/addStories/addStoriesMobile";
import Dashboard from "./containers/dashboard";
import FamilyTree from "./containers/familyTree";
import ForgotPassword from "./containers/forgotPassword";
import Login from "./containers/login";
import Register from "./containers/register";
import SingleStoriesMobile from "./containers/singleStories/singleStoriesMobile";
import SingleNewsMobile from "./containers/singlenews/singleNewsMobile";
import About from "./containers/static/about";
import Contact from "./containers/static/contact";
import CookiesPolicy from "./containers/static/cookiesPolicy";
import Disclaimer from "./containers/static/disclaimer";
import PersonalityOne from "./containers/static/people/personality-one";
import PersonalityTwo from "./containers/static/people/personality-two";
import PrivacyPolicy from "./containers/static/privacyPolicy";
import TermsofService from "./containers/static/termsofService";
import VerifyEmail from "./containers/verifyEmail";
import VerifyPhone from "./containers/verifyPhone";
import SessionDetails from "./helpers/sessionDetails";
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

function App() {
  useEffect(() => {
    console.log(process.env.REACT_APP_BASE_URL);
  }, []);
  return (
    <div className={"mainDiv"}>
      <ResponsiveDialog />
      <Snackbar />
      <BrowserRouter>
        <React.Suspense fallback={loading()}>
          <div>
            <Routes>
              <Route
                exact
                path={PATH.LOGIN_SCREEN}
                name={TITLE.LOGIN_SCREEN}
                element={<Login />}
              />
              <Route
                exact
                path={PATH.REGISTER_SCREEN}
                name={TITLE.REGISTER_SCREEN}
                element={<Register />}
              />

              <Route
                exact
                path={PATH.VERIFY_EMAIL}
                name={TITLE.VERIFY_EMAIL}
                element={<VerifyEmail />}
              />

              <Route
                exact
                path={PATH.VERIFY_PHONE}
                name={TITLE.VERIFY_PHONE}
                element={<VerifyPhone />}
              />

              <Route
                exact
                path={PATH.FORGOT_PASSWORD}
                name={TITLE.FORGOT_PASSWORD}
                element={<ForgotPassword />}
              />

              <Route
                exact
                path={PATH.ABOUT_SCREEN}
                name={TITLE.ABOUT_SCREEN}
                element={<About />}
              />
              <Route
                exact
                path={PATH.TERMS_OF_SERVICE_SCREEN}
                name={TITLE.TERMS_OF_SERVICE_SCREEN}
                element={<TermsofService />}
              />

              <Route
                exact
                path={PATH.PRIVACY_POLICY_SCREEN}
                name={TITLE.PRIVACY_POLICY_SCREEN}
                element={<PrivacyPolicy />}
              />

              <Route
                exact
                path={PATH.COOKIES_POLICY_SCREEN}
                name={TITLE.COOKIES_POLICY_SCREEN}
                element={<CookiesPolicy />}
              />

              <Route
                exact
                path={PATH.DISCLAIMER_SCREEN}
                name={TITLE.DISCLAIMER_SCREEN}
                element={<Disclaimer />}
              />

              <Route
                exact
                path={PATH.CONTACTS_SCREEN}
                name={TITLE.CONTACTS_SCREEN}
                element={<Contact />}
              />
              <Route
                exact
                path={PATH.PERSONALITY_ONE}
                name={TITLE.PERSONALITY_ONE}
                element={<PersonalityOne />}
              />
              <Route
                exact
                path={PATH.PERSONALITY_TWO}
                name={TITLE.PERSONALITY_TWO}
                element={<PersonalityTwo />}
              />
              <Route
                exact
                path={PATH.FAMILY_TREE_PUBLIC}
                name={""}
                element={<FamilyTree />}
              />
              <Route
                exact
                path={PATH.SINGLE_NEWS_MOBILE}
                name={""}
                element={<SingleNewsMobile />}
              />
              <Route
                exact
                path={PATH.SINGLE_STORY_MOBILE}
                name={""}
                element={<SingleStoriesMobile />}
              />
              <Route
                exact
                path={PATH.ADD_NEWS_MOBILE}
                name={""}
                element={<AddNewsMobile />}
              />
              <Route
                exact
                path={PATH.ADD_STORY_MOBILE}
                name={""}
                element={<AddStoriesMobile />}
              />
              <Route
                path={PATH.DASHBOARD_SCREEN}
                element={
                  <ProtectedRoute
                    path={PATH.DASHBOARD_SCREEN}
                    name={TITLE.DASHBOARD_SCREEN}
                    validator={() => SessionDetails.isUserLoggedIn()}
                    component={Dashboard}
                  />
                }
              />
            </Routes>
          </div>
        </React.Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
// "start": "set HTTPS=true&&set SSL_CRT_FILE=C:\\Users\\Broadstairs\\Documents\\Projects\\Reactjs\\memonid-react\\cert\\cert.crt&&set SSL_KEY_FILE=C:\\Users\\Broadstairs\\Documents\\Projects\\Reactjs\\memonid-react\\cert\\cert.key&&react-scripts start",
